import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  buttons: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(2.5),
    '& button:nth-child(1)': {
      height: 34,
      width: 89,
    },
    '& button:nth-child(2)': {
      color: theme.palette.primary1,
      height: 34,
      width: 89,
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(2),
      '& button': {
        fontSize: 14,
      },
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      '& button': {
        height: '44px !important',
        width: '50% !important',
      },
    },
  },
  cards: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.down('sm')]: {
      '& div:nth-child(3)': {
        width: '100%',
      },
    },
  },
}));
